import { Box } from "theme-ui";

export default function VideoPlayIcon() {
  return (
    <Box
      as="svg"
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 30C0 13.4315 13.4315 0 30 0C46.5685 0 60 13.4315 60 30C60 46.5685 46.5685 60 30 60C13.4315 60 0 46.5685 0 30Z"
        fill="black"
      />
      <circle cx="30" cy="30" r="12" stroke="white" strokeWidth="2" />
      <path d="M27 25.5L34.5 30L27 34.5V25.5Z" stroke="white" strokeWidth="2" />
    </Box>
  );
}
